module.exports = __webpack_public_path__ + "static/media/prv3.ca0ff0e7.jpg";